module.exports = __webpack_public_path__ + "img/polar.bfa6527c.svg";